import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift } from 'lucide-react';
export function WhatYouGet() {
  const benefits = ['Consulta personalizada sin costo ni compromiso', 'Análisis completo de tu situación familiar', 'Comparación de planes adaptados a tu presupuesto', 'Proceso de aplicación manejado por mí de inicio a fin', 'Seguimiento después de que tengas tu plan activo', 'Atención en español 100% personalizada', 'Verificación inmediata de tu elegibilidad para inscribirte hoy', 'Disponibilidad para responder tus dudas cuando las tengas'];
  return <section className="py-10 md:py-24 bg-navy text-white relative" data-id="element-373">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-374">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-375">
          <div className="flex justify-center mb-4" data-id="element-376">
            <Gift className="w-12 h-12 text-gold" data-id="element-377" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-378">
            LO QUE RECIBES CUANDO ME CONTACTAS
          </h2>
          <p className="text-xl text-white/80" data-id="element-379">
            Cuando te comunicas conmigo, recibes{' '}
            <span className="text-gold font-bold" data-id="element-380">GRATIS:</span>
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-381">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-navy-light p-6 rounded-xl border border-white/5 hover:border-gold/30 transition-colors" data-id="element-382">
              <div className="bg-gold/20 p-2 rounded-full shrink-0 mt-1" data-id="element-383">
                <Check className="w-5 h-5 text-gold" data-id="element-384" />
              </div>
              <span className="text-lg text-white/90 leading-relaxed" data-id="element-385">
                {benefit}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-16 text-center max-w-2xl mx-auto bg-white/5 p-8 rounded-2xl border border-white/10" data-id="element-386">
          <p className="text-lg text-white/90 mb-4" data-id="element-387">
            Todo esto sin costo adicional para ti. Mi servicio es completamente{' '}
            <strong className="text-gold" data-id="element-388">GRATUITO</strong> para ti como
            cliente.
          </p>
          <p className="text-lg text-white/90" data-id="element-389">
            Las aseguradoras me pagan a mí directamente. Tú solo pagas tu plan,
            nunca mis servicios.
          </p>
        </motion.div>
      </div>
    </section>;
}